import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { FloatingFilterDisplayParams, TextFilterModel } from "ag-grid-community";
import { IFloatingFilterDisplayAngularComp } from "ag-grid-angular";

@Component({
    standalone: true,
    imports: [FormsModule],
    templateUrl: "./ag-grid-filter.component.html",
    styleUrl: `./ag-grid-filter.component.scss`
})
export class AgGridFilterComponent implements IFloatingFilterDisplayAngularComp {
    params!: FloatingFilterDisplayParams;
    filterValue: string = "";

    onInputChange(): void {
        if (this.filterValue === "") {
            this.params.onModelChange(null);
            return;
        }
        const filterModel: TextFilterModel = {
            filterType: "text",
            type: "contains",
            filter: this.filterValue
        };
        this.params.onModelChange(filterModel);
    }

    refresh(params: FloatingFilterDisplayParams): void {
        this.params = params;
    }

    agInit(params: FloatingFilterDisplayParams): void {
        this.params = params;
    }
}
